module.exports = __webpack_public_path__ + "img/stickers_0012_girlx.d8fde253.png";